export class CaseTypeDeletionImpactEntity {
  public activeCasesCount!: number;
  public linkedCases!: LinkedCaseEntity[];
  public linkedCaseForms!: LinkedCaseFormEntity[];
  public linkedEmailTemplates!: LinkedEmailTemplateEntity[];
  public linkedProcessChecklists!: LinkedProcessChecklistEntity[];
  public hasDependencies!: boolean;
}

export class LinkedCaseEntity {
  public id!: string;
  public name!: string;
}

export class LinkedCaseFormEntity {
  public id!: string;
  public name!: string;
}

export class LinkedEmailTemplateEntity {
  public id!: string;
  public name!: string;
}

export class LinkedProcessChecklistEntity {
  public id!: string;
  public name!: string;
}
